import React, { useEffect, useRef } from 'react';

const INSTAGRAM_EMBED_SRC = 'https://www.instagram.com/embed.js';

/** Strip script tags; only blockquote markup is kept (scripts loaded separately). */
function sanitizeInstagramEmbedHtml(html) {
  const raw = String(html || '').trim();
  if (!raw) return '';
  return raw.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
}

function loadInstagramEmbedScript() {
  if (typeof document === 'undefined') return;
  const existing = document.querySelector(`script[src="${INSTAGRAM_EMBED_SRC}"]`);
  if (existing) {
    if (typeof window !== 'undefined' && typeof window.instgrm?.Embeds?.process === 'function') {
      window.instgrm.Embeds.process();
    }
    return;
  }
  const script = document.createElement('script');
  script.src = INSTAGRAM_EMBED_SRC;
  script.async = true;
  script.onload = () => {
    if (typeof window.instgrm?.Embeds?.process === 'function') {
      window.instgrm.Embeds.process();
    }
  };
  document.body.appendChild(script);
}

/** Renders admin-configured Instagram blockquote embeds (scripts loaded from instagram.com only). */
export default function InstagramEmbed({ html }) {
  const ref = useRef(null);
  const safeHtml = sanitizeInstagramEmbedHtml(html);

  useEffect(() => {
    if (!safeHtml) return;
    loadInstagramEmbedScript();
  }, [safeHtml]);

  if (!safeHtml) return null;

  return (
    <div
      ref={ref}
      className="instagram-embed-widget text-center"
      dangerouslySetInnerHTML={{ __html: safeHtml }}
    />
  );
}
